import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Drawer, Input, Field, Select } from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const EditAgencyRole = ({ agencies, member, role, onClose, onSave, show }) => {
  const fallback_role = role || {};
  const [data, setData] = useState({
    member_id: fallback_role.member_id || member.id,
    name: fallback_role.name || 'member',
    agency_id: fallback_role.agency_id,
    permissions: fallback_role.permissions || [],
    applicint_trusted_code: fallback_role.applicint_trusted_code || ''
  });

  useEffect(() => {
    const new_role = Object.assign(
      {},
      {
        member_id: fallback_role.member_id || member.id,
        name: fallback_role.name || 'member',
        agency_id: fallback_role.agency_id,
        permissions: fallback_role.permissions || [],
        applicint_trusted_code: fallback_role.applicint_trusted_code || ''
      }
    );

    setData(new_role);
  }, [role]);

  const handleInputChange = (name, e) => {
    const updated_data = { ...data, [name]: e.target.value };

    if (name === 'name' && e.target.value === 'admin') {
      updated_data.permissions = [];
    }

    setData(updated_data);
  };

  const handlePermissionsChange = permissions => {
    setData({ ...data, permissions });
  };

  const handleSave = () => {
    Api.saveMemberAgencyRole(role.id, data).then(() => {
      onSave();
    });
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>
          {role && role.id ? 'Update Agency Role' : 'Create Agency Role'}
        </Button>
      }
      onClose={onClose}
      show={show}
      title={role && role.id ? 'Editing Role' : 'New Role'}
    >
      {fallback_role.agency_id ? null : (
        <Field label='Agency'>
          <Select
            onChange={handleInputChange.bind(null, 'agency_id')}
            options={agencies.map(a => ({ value: a.id, label: a.name }))}
            value={data.agency_id}
          />
        </Field>
      )}
      <Field label='Role'>
        <Select
          onChange={handleInputChange.bind(null, 'name')}
          options={[
            { value: 'member', label: 'Member' },
            { value: 'sales_rep', label: 'Sales Rep' },
            { value: 'admin', label: 'Admin' }
          ]}
          value={data.name}
        />
      </Field>
      {data.name !== 'admin' ? (
        <Field label='Permissions'>
          <Checklist
            onChange={handlePermissionsChange}
            options={[
              { value: 'billing', label: 'Billing' },
              { value: 'agency_forms', label: 'Agency Forms' },
              { value: 'notification_triggers', label: 'Notification Triggers' }
            ]}
            selected={data.permissions}
          />
        </Field>
      ) : null}
      <Field label='Applicint Trusted Code'>
        <Input
          onChange={handleInputChange.bind(null, 'applicint_trusted_code')}
          value={data.applicint_trusted_code}
        />
      </Field>
    </Drawer>
  );
};

EditAgencyRole.propTypes = {
  agencies: PropTypes.array,
  member: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  role: PropTypes.object,
  show: PropTypes.bool
};

export default EditAgencyRole;
